import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const Play = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '25',
    style,
    strokeAsPrimary: true,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill={primaryColorToUse}
      viewBox='0 0 24 24'
    >
      <path
        stroke={primaryColorToUse}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='m6 3 14 9-14 9z'
      />
    </svg>
  );
};
